export default __webpack_public_path__ + "success-modal-icon.png";